import React from 'react'
import Component from 'ui/pages/LegacyBrowser'

const LegacyBrowser: React.FC = () => {
  return <Component />
}

export default LegacyBrowser
